<template>
  <div class="nav-tree-item">
    <button
      type="button"
      class="nav-link folder-link"
      data-testid="dash-folder-node"
      :class="{ active: isActive, disabled: !isAllowed, 'is-drop-target': isDropTarget }"
      :style="{ paddingLeft: paddingLeft }"
      :data-folder-id="folder.id"
      @click="onSelect"
      @dragenter.prevent="onDragEnter"
      @dragover.prevent="onDragOver"
      @dragleave="onDragLeave"
      @drop.prevent="onDrop"
    >
      <span v-if="children.length" class="caret-toggle mr-1" @click.stop="onToggle">
        <i :class="collapsed ? 'fas fa-caret-right' : 'fas fa-caret-down'"></i>
      </span>
      <span v-else class="caret-placeholder mr-1"></span>
      <i class="fas fa-folder mr-2"></i>
      <span class="text-truncate">{{ folder.name }}</span>
    </button>
    <div v-if="children.length && !collapsed" class="folder-children">
      <folder-node
        v-for="child in children"
        :key="child.id"
        :folder="child"
        :get-children="getChildren"
        :is-collapsed="isCollapsed"
        :toggle-folder="toggleFolder"
        :select-folder="selectFolder"
        :selected-folder-id="selectedFolderId"
        :allowed-folder-ids="allowedFolderIds"
        :drag-target-folder-id="dragTargetFolderId"
        :is-dragging="isDragging"
        :no-drop-folder-ids="noDropFolderIds"
        :on-folder-drop="onFolderDrop"
        :on-folder-drag-enter="onFolderDragEnter"
        :on-folder-drag-leave="onFolderDragLeave"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FolderNode',
  props: {
    folder: { type: Object, required: true },
    getChildren: { type: Function, required: true },
    isCollapsed: { type: Function, required: true },
    toggleFolder: { type: Function, required: true },
    selectFolder: { type: Function, required: true },
    selectedFolderId: { type: [Number, String, null], required: true },
    allowedFolderIds: { type: [Array, null], default: null },
    dragTargetFolderId: { type: [Number, String, null], default: null },
    isDragging: { type: Boolean, default: false },
    // 掴んだフォルダ自身とその配下。落とし先として強調しない (落とされたときの扱いは onFolderDrop 側で決める)
    noDropFolderIds: { type: Array, default: () => [] },
    onFolderDrop: { type: Function, default: null },
    onFolderDragEnter: { type: Function, default: null },
    onFolderDragLeave: { type: Function, default: null },
    depth: { type: Number, default: 1 },
  },
  computed: {
    isAllowed() {
      if (this.allowedFolderIds === null) {
        return true;
      }
      return this.allowedFolderIds.includes(this.folder.id);
    },
    paddingLeft() {
      return `${12 + Math.max(0, (this.depth - 1) * 12)}px`;
    },
    children() {
      return this.getChildren(this.folder.id);
    },
    collapsed() {
      return this.isCollapsed(this.folder.id);
    },
    isActive() {
      return String(this.selectedFolderId ?? '') === String(this.folder.id);
    },
    isDropTarget() {
      if (!this.isDragging || !this.isAllowed) {
        return false;
      }
      if (this.noDropFolderIds.some((id) => Number(id) === Number(this.folder.id))) {
        return false;
      }
      return String(this.dragTargetFolderId ?? '') === String(this.folder.id);
    },
  },
  methods: {
    onToggle(e) {
      e.stopPropagation();
      this.toggleFolder(this.folder.id);
    },
    onSelect() {
      if (!this.isAllowed) {
        return;
      }
      this.selectFolder(this.folder.id);
    },
    onDragEnter(e) {
      if (!this.isAllowed || !this.onFolderDragEnter) {
        return;
      }
      this.onFolderDragEnter(this.folder.id, e);
    },
    onDragOver(e) {
      if (!this.isAllowed || !this.onFolderDragEnter) {
        return;
      }
      this.onFolderDragEnter(this.folder.id, e);
    },
    onDragLeave(e) {
      if (!this.isAllowed || !this.onFolderDragLeave) {
        return;
      }
      this.onFolderDragLeave(this.folder.id, e);
    },
    onDrop(e) {
      if (!this.isAllowed || !this.onFolderDrop) {
        return;
      }
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
      this.onFolderDrop(this.folder.id, e);
    },
  },
};
</script>
